import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useTimeEntryPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "time_entries:read"),
    canWrite: roleHasPermission(role, "time_entries:write"),
    canSubmit: roleHasPermission(role, "time_entries:submit_day"),
    canViewPayroll: roleHasPermission(role, "payroll:sensitive"),
    canViewEquipmentCosts: roleHasPermission(role, "payroll:sensitive"),
    role,
  };
}
